import { Button, Checkbox, CodeInput, Modal, ModalActions, ModalBanner, ModalContent, ModalHeader, ModalSidebar, } from '@lightspeed/design-system-react';
import { T, useT, UT } from '@transifex/react';
import { VendImage } from '@vend/react-utilities';
import React, { useEffect, useState } from 'react';
import { withTranslations } from '../../tx';
import { getClientType } from './utils';
const OTPModalUnconnected = ({ onClickNoAuthApp, onComplete, isInvalidOTP, hasInternalError, isSubmitting, onClose, authType = 'signin', dismissable = true, }) => {
    const t = useT();
    const isSignin = authType === 'signin';
    const [otp, setOtp] = useState('');
    const [rememberMe, setRememberMe] = useState(false);
    const [shouldShowError, setShouldShowError] = useState(false);
    const clientType = getClientType();
    const isMobileApp = clientType === 'ios' || clientType === 'android';
    const invalidOTPErrorMessage = t('Invalid authentication code entered. Please try again.', {
        _comment: 'erorr message for invalid otp code entered on the OTP modal.',
    });
    useEffect(() => {
        if (isSubmitting) {
            return;
        }
        // clear otp if it's invalid
        if (isInvalidOTP) {
            setOtp('');
        }
        setShouldShowError(true);
    }, [isInvalidOTP, isSubmitting]);
    const handleChange = (code, done) => {
        setOtp(code);
        setShouldShowError(false);
        if (!done) {
            return;
        }
        const mfa = {
            type: 'OTP',
            password: code,
            remember_me: rememberMe,
        };
        onComplete(mfa);
    };
    const toggleRememberMe = () => setRememberMe(!rememberMe);
    const renderPrompt = () => {
        const CONTEXT = 'Link to support article about multifactor authentication codes';
        const COMMENT = 'Used as the {helpLink} for the multifactor authentication prompt';
        return (React.createElement("p", { className: "vd-p" }, isSignin ? (React.createElement(T, { _str: 'To finish signing in, enter the authentication code generated by your authentication app. {helpLink}', _context: "Multifactor authentication prompt for signing in", helpLink: React.createElement(UT, { _inline: true, _str: `<a href="https://x-series-support.lightspeedhq.com/hc/en-us/articles/360003973336" className="vd-link" rel="noopener noreferrer" target="_blank">How do I find my authentication code?</a>`, _context: CONTEXT, _comment: COMMENT }) })) : (React.createElement(T, { _str: 'To finish user switching, enter the authentication code generated by your authentication app. {helpLink}', _context: "Multifactor authentication prompt for user switching", helpLink: React.createElement(UT, { _inline: true, _str: `<a href="https://x-series-support.lightspeedhq.com/hc/en-us/articles/360003973336" className="vd-link" rel="noopener noreferrer" target="_blank">How do I find my authentication code?</a>`, _context: CONTEXT, _comment: COMMENT }) }))));
    };
    return (React.createElement(Modal, { focusTrapActive: !isSignin, pageModal: isSignin, size: isSignin ? 'medium-with-sidebar' : 'small-with-sidebar', onClose: onClose, dismissable: dismissable },
        React.createElement(ModalSidebar, { className: "vd-flex vd-align-center" },
            React.createElement(VendImage, { className: "mfa-modal-sidebar-image", relativeImagePath: "signin/enter-otp-v1.svg", alt: t('MFA OTP image', { _context: 'image alt' }) })),
        shouldShowError && hasInternalError && (React.createElement(ModalBanner, { variant: "negative" },
            React.createElement("p", { className: "vd-p" },
                React.createElement(T, { _str: 'Something went wrong. Please {refreshButton} to try again, or {helpLink} if this problem continues.', _context: "Multifactor authentication error message", refreshButton: React.createElement(Button, { "data-track": "otp-modal-refresh", link: true, onClick: () => window.location.reload() }, t('refresh', {
                        _context: 'refresh try again',
                        _comment: 'Used as the {refreshButton} for the multifactor authentication error message',
                    })), helpLink: React.createElement(UT, { _inline: true, _str: `<a href="https://x-series-support.lightspeedhq.com/hc/en-us" className="vd-link" rel="noopener noreferrer" target="_blank">contact Lightspeed Retail Support</a>`, _context: "Contact support help link", _comment: "Used as the {helpLink} link for the multifactor authentication error message" }) })))),
        React.createElement(ModalHeader, null, t('Enter your authentication code', { _context: 'otp modal header' })),
        React.createElement(ModalContent, null,
            renderPrompt(),
            !isMobileApp && (React.createElement("div", { className: "vd-field" },
                React.createElement(Checkbox, { label: t('Remember me on this device for 30 days.'), checked: rememberMe, onChange: toggleRememberMe }))),
            React.createElement("div", { className: "vd-field otp-modal-code-input-wrapper" },
                React.createElement(CodeInput, { isOTP: true, code: otp, onCodeDigitChange: handleChange, errorMessage: isInvalidOTP && shouldShowError
                        ? invalidOTPErrorMessage
                        : undefined }))),
        React.createElement(ModalActions, { className: "vd-flex vd-flex--align-center vd-flex--justify-between" },
            React.createElement(Button, { "data-track": "otp-modal-no-auth-app", link: true, onClick: onClickNoAuthApp }, t('I can’t access my authenticator app.', {
                _context: 'otp modal - button link',
            })),
            React.createElement(Button, { "data-track": `opt-modal-${isSignin ? 'sign-in' : 'switch-user'}`, variant: "go", disabled: true, loading: isSubmitting, name: "otp_submit" }, isSignin
                ? t('Sign in', { _context: 'Button' })
                : t('Switch user', { _context: 'Button' })))));
};
export const OTPModal = withTranslations(OTPModalUnconnected, 
// eslint-disable-next-line i18next/no-literal-string
'OTPModal');
